module.exports = __webpack_public_path__ + "static/media/main6.34ece405.jpeg";